/**
 * A time with its meridiem set back: the digits are what is read off a
 * schedule, and AM/PM only disambiguates. Styled by the home page's figure
 * classes, so it reads the same in the hero, the sheet's days and the band.
 */
export function Time({ value }: { value: string }) {
  const m = /^(\d{1,2}:\d{2})\s*(AM|PM)$/i.exec(value.trim())
  if (!m) return <>{value}</>
  return (
    <span className="home__figure">
      {m[1]}
      <span className="home__meridiem">{m[2]}</span>
    </span>
  )
}
